<template>
  <div class="row">
    <div class="col-12">
      <!-- 평가대상 목록 - 유해위험요인 -->
      <c-table
        ref="table"
        title="LBL0001108"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="process.thirdScenarios"
        :columnSetting="false"
        :expandAll="false"
        :isFullScreen="false"
        :usePaging="false"
        :hideBottom="true"
        :filtering="false"
        :editable="editable&&!disabled&&isSelect"
        selection="multiple"
        rowKey="ramThirdAssessScenarioId"
      >
        <!-- @rowClick="rowClick" -->
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-show="editable&&!disabled&&isSelect" label="직접추가" icon="add" @btnClicked="addKeyinRiskHazard" />
            <c-btn v-show="editable&&!disabled&&isSelect" label="추가(순회점검)" icon="add" @btnClicked="addRiskHazard" />
            <c-btn v-show="editable&&!disabled&&isSelect" label="LBLREMOVE" icon="remove" @btnClicked="removeRiskHazard" />
            <c-btn 
              v-show="editable&&!disabled&&isSelect" 
              :isSubmit="isSave"
              :url="saveUrl"
              :param="process.thirdScenarios"
              mappingType="PUT"
              label="LBLSAVE" 
              icon="save"
              @beforeAction="saveRiskHazard"
              @btnCallback="saveRiskHazardCallback" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'Third-target-process',
  props: {
    assessPlan: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        plantCd: '',
        ramStepCd: '',
        ramTechniqueCd: '',  // 평가기법 코드_HAZOP/KRAS/JSA/CHECKLIST
        processes: [], // 대상공정 목록
      }),
    },
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        regUserId: '',  // 작성자 ID
        chgUserId: '',  // 수정자 ID
        equipments: [],
        thirdScenarios: [],
      }),
    },
    disabled: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    updateBtnData: {
      type: Object,
      default: () => ({
        flag: false,
        research: '',
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'hazardDisasterTypeCd',
            field: 'hazardDisasterTypeCd',
            label: '재해유형',
            align: 'center',
            style: 'width:20%',
            sortable: true,
            type: 'multiSelect',
            codeGroupCd: 'HAZARD_DISASTER_TYPE_CD',
            isArray: false,
            required: true,
          },
          {
            name: 'riskHazardQuestionName',
            field: 'riskHazardQuestionName',
            // 유해위험요인<br/>(위험한 상황과 사건)
            label: 'LBL0001116',
            align: 'left',
            style: 'width:80%',
            sortable: true,
            type: 'textarea',
            required: true,
          },
        ],
        data: [],
        height: '550px'
      },
      editable: true,
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
      isSave: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    isSelect() {
      return this.process 
        && this.process.processCd
        && this.process.ramProcessAssessStepCd !== 'RPA0000005' ? true : false
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.third.scenario.list.url
      this.saveUrl = transactionConfig.ram.third.scenario.save.url
      this.deleteUrl = transactionConfig.ram.third.scenario.delete.url
      // code setting
      // list setting
    },
    getScenarios() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,
        processCd: this.process.processCd
      }
      this.$http.request((_result) => {
        this.process.thirdScenarios = _result.data
      },);
    },
    addKeyinRiskHazard() {
      if (!this.process.thirdScenarios) this.process.thirdScenarios = [];
      this.process.thirdScenarios.splice(0, 0, {
        ramThirdAssessScenarioId: uid(),  // 시나리오 일련번호_시나리오의 한 라인(원일별)
        ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,  // 평가 일련번호
        processCd: this.process.processCd,  // 단위공정 코드
        processName: this.process.processName,  // 단위공정
        hazardDisasterTypeCd: null,  // 유해위험요인 질문
        riskHazardQuestionName: '',  // 유해위험요인 질문
        ramRiskThirdStandardId: '',  // 3단계 판단결과
        riskColor: '',  // 위험색상
        regUserId: this.$store.getters.user.userId,  // 작성자 ID
        editFlag: 'C'
      })
    },
    addRiskHazard() {
      this.popupOptions.title = '순회점검 유해위험요인 도출정보';
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.assessPlan.plantCd
      };
      this.popupOptions.target = () => import(`${'@/pages/sai/patrol/patrolRiskAssessmentPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeRiskHazardPopup;
    },
    closeRiskHazardPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        if (!this.process.thirdScenarios) this.process.thirdScenarios = [];
        this.$_.forEach(data, item => {
          this.process.thirdScenarios.splice(0, 0, {
            ramThirdAssessScenarioId: uid(),  // 시나리오 일련번호_시나리오의 한 라인(원일별)
            ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,  // 평가 일련번호
            processCd: this.process.processCd,  // 단위공정 코드
            processName: this.process.processName,  // 단위공정
            hazardDisasterTypeCd: item.hazardDisasterTypeCd,  // 유해위험요인 질문
            riskHazardQuestionName: item.patrolContents,  // 유해위험요인 질문
            currentSafetyMeasures: item.actionContents,  // 유해위험요인 질문
            ramRiskThirdStandardId: '',  // 3단계 판단결과
            riskColor: '',  // 위험색상
            regUserId: this.$store.getters.user.userId,  // 작성자 ID
            editFlag: 'C'
          })
        })
      }
    },
    saveRiskHazard() {
      if (this.$comm.validTable(this.grid.columns, this.process.thirdScenarios)) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveRiskHazardCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('saveProcess', this.process.processCd)
      this.getScenarios();
      /**
       * 계획정보수정
       *  변경사항을 적용하기 위함
       */
      if (this.updateBtnData.flag) {
        this.updateBtnData.research = uid();
      }
    },
    removeRiskHazard() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        let message = 'MSGREMOVE'; // 삭제하시겠습니까?
        if (this.updateBtnData.flag) {
          // 현재 평가실행 중인 유해위험요인입니다.\n\r관련되어 있는 정보 및 개선사항, 위험등록부가 같이 삭제됩니다.\n\r진행하시겠습니까?
          message = 'MSG0000387'
        }
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: message,
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.process.thirdScenarios = this.$_.reject(this.process.thirdScenarios, item);
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();

              /**
               * 계획정보수정
               *  변경사항을 적용하기 위함
               */
              if (this.updateBtnData.flag) {
                this.updateBtnData.research = uid();
              }
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
